import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds === 0) {
          if (prev.minutes === 0) {
            clearInterval(timer);
            return prev;
          }
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return {
          ...prev,
          seconds: prev.seconds - 1
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex items-center justify-center gap-3 text-teal-400 font-medium bg-teal-500/10 border border-teal-500/20 px-5 py-3 rounded-xl" data-id="element-13">
      <span className="text-2xl" data-id="element-14">🚀</span>
      <span className="text-sm md:text-base" data-id="element-15">
        Lanzamiento oficial —{' '}
        <span className="font-bold text-white" data-id="element-16">Sé de los primeros</span> en
        acceder
      </span>
    </div>;
}